'use client';

import { BlogLayout } from '../components/BlogLayout';
import type { BlogPostMeta } from '../lib/posts';

interface BlogPostContentProps {
  slug: string;
  title: string;
  author: string;
  publishDate: string;
  readingTime?: string;
  content: string;
  relatedPosts?: BlogPostMeta[];
}

export function BlogPostContent({
  slug,
  title,
  author,
  publishDate,
  readingTime,
  content,
  relatedPosts,
}: BlogPostContentProps) {
  return (
    <BlogLayout
      slug={slug}
      title={title}
      author={author}
      publishDate={publishDate}
      readingTime={readingTime}
      content={content}
      relatedPosts={relatedPosts}
    />
  );
}
